import React, { useState } from 'react';
import { Smartphone, Monitor, Info } from 'lucide-react';
import { MobilePreview } from './components/mobile/MobilePreview';
import { WebPreview } from './components/web/WebPreview';
type Mode = 'mobile' | 'web';
export function App() {
  const [mode, setMode] = useState<Mode>('mobile');
  return <div className="flex min-h-screen w-full flex-col bg-slate-100 font-rounded text-slate-800" data-id="element-0" data-mp="3fbjar2g4druw">
      <PreviewSwitcher mode={mode} onChange={setMode} data-id="element-1" data-mp="2rlyr0hc56qkk" />
      <main className="flex w-full flex-1 items-start justify-center px-4 py-6" data-id="element-2" data-mp="2rikqzfqyatga">
        {mode === 'mobile' ? <MobilePreview data-id="element-3" data-mp="31aqdi9yfoio3" /> : <WebPreview data-id="element-4" data-mp="31b8ka0iq2fa9" />}
      </main>
    </div>;
}
function PreviewSwitcher({
  mode,
  onChange
}: {
  mode: Mode;
  onChange: (m: Mode) => void;
}) {
  return <header className="sticky top-0 z-50 flex w-full flex-col gap-3 border-b border-slate-200 bg-white/90 px-4 py-3 backdrop-blur sm:flex-row sm:items-center sm:justify-between sm:px-6" data-id="element-5" data-mp="2whxbhtucnofp">
      <div className="flex items-center gap-3" data-id="element-6" data-mp="23v2sz2h3ez4v">
        <div className="flex h-9 items-center rounded-md bg-[#1e2a5a] px-3 font-heading text-sm font-bold tracking-tight text-white" data-id="element-7" data-mp="3ikha0f5th31m">
          RANGEET
        </div>
        <div className="hidden flex-col leading-tight sm:flex" data-id="element-8" data-mp="3mj6ipufwtwex">
          <span className="font-heading text-sm font-semibold text-slate-900" data-id="element-9" data-mp="3rdkgu4lyihna">
            Family App
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3" data-id="element-10" data-mp="2zl3alhpbj03q">
        <span className="hidden items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-500 md:flex" data-id="element-11" data-mp="2zmeowbge3q93">
          <Info className="h-3.5 w-3.5" data-id="element-12" data-mp="33myl9ct52pu6" />
          {mode === 'mobile' ? 'Flutter native app + Family App WebView' : 'Family App admin panel (web)'}
        </span>
        <div role="tablist" aria-label="Preview surface" className="flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 p-1" data-id="element-13" data-mp="3dmfolnkx4rmz">
          <SwitchButton active={mode === 'mobile'} onClick={() => onChange('mobile')} icon={<Smartphone className="h-4 w-4" data-id="element-15" data-mp="34nabp7octvk" />} label="Mobile" data-id="element-14" data-mp="stc864jdl0nw" />
          <SwitchButton active={mode === 'web'} onClick={() => onChange('web')} icon={<Monitor className="h-4 w-4" data-id="element-17" data-mp="d45vg8zbmlp7" />} label="Web" data-id="element-16" data-mp="3ubztuaw15jen" />
        </div>
      </div>
    </header>;
}
function SwitchButton({
  active,
  onClick,
  icon,
  label
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}) {
  return <button role="tab" aria-selected={active} onClick={onClick} className={`flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${active ? 'bg-[#1e2a5a] text-white shadow-sm' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-18" data-mp="3bnmfji6q357t">
      {icon}
      {label}
    </button>;
}